export default __webpack_public_path__ + "4e6339bcf5c199f72253dfcb5ec3ff2c.png";